/**
 * Branded full-screen splash while auth session / profile loads.
 * Uses /logo.png from public (same asset as native splash).
 */
export default function SplashScreen() {
  const logoSrc = `${process.env.PUBLIC_URL || ""}/logo.png`;

  return (
    <div className="eh-splash-screen" role="status" aria-live="polite" aria-busy="true">
      <div className="eh-splash-screen__inner">
        <img
          src={logoSrc}
          alt=""
          className="eh-splash-screen__logo"
          width={180}
          height={180}
          decoding="async"
        />
        <p className="eh-splash-screen__loading">Loading…</p>
      </div>
    </div>
  );
}
